import { render, staticRenderFns } from "./TransactionsPage.vue?vue&type=template&id=3d46e74d&scoped=true&"
import script from "./TransactionsPage.vue?vue&type=script&lang=ts&"
export * from "./TransactionsPage.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionsPage.vue?vue&type=style&index=0&id=3d46e74d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d46e74d",
  null
  
)

export default component.exports